/* eslint-disable */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
import {
  Grid,
  Typography,
  Box,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
// import '../../../ThemeStyle.css';
import { useAppData } from '../../../hooks/useAppData';
import { useNavigate, useParams, useLocation } from 'react-router';
import ApplianceOptions from '../../../components/ApplianceOptions';
import Image from '../../../components/DynamicImages';
import { useStorage } from '../../../hooks/useStorage';
import { Link } from 'react-router-dom';
import { displayCurrency, pricingHelper } from '../../../utils';
import SimpleDialog from '../../../components/Dialog';
import SaveIcon from '@mui/icons-material/Save';
import useDealer from '../../../hooks/useDealer';

const ProductStudioStage1 = () => {
  const navigate = useNavigate();

  const { parentPath } = useDealer();

  const { appliances: applianceName } = useParams();

  const fireviewKitchen = parentPath === 'fireview';

  const { selectedApplianceData, genrateApplianceImage, appDataState } =
    useAppData();

  const { data, applianceData, configuredData } = appDataState;
  const modelStylesData = applianceData?.styles;
  const modelOptionsData = applianceData?.modelOptions;
  const configuredApplianceData = configuredData?.[applianceName];
  // const storedConfiguredData = JSON.parse(localStorage.getItem(parentPath))?.[
  //   applianceName
  // ]?.configuration;

  useEffect(() => {
    if (data && !data?.configuratorIcon.find((el) => el.id === applianceName)) {
      navigate('../');
    }
  }, [data, applianceName, navigate]);

  const {
    appliance,
    setAppliance,
    modelOptions,
    setModelOptions,
    save,
    reset,
    localItem,
  } = useStorage(parentPath, applianceName);

  // Internal state
  const [modelPricing, setModelPricing] = useState({});
  const [selectionChanged, setSelectionChanged] = useState(false);
  const [boxHeight, setBoxHeight] = useState(0);
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  // Auto close selections saved popup.
  useEffect(() => {
    if (open) {
      setTimeout(() => handleClose(), 900);
    }
  }, [open]);

  // load selected appliances data from JSON
  useEffect(() => {
    selectedApplianceData(applianceName, data);
  }, [data, selectedApplianceData, applianceName]);

  const stepByStepOptions = (options, selectedKey) => {
    return options.reduce((acc, currValue, currIndex) => {
      if (currValue?.id === 'colours' && selectedKey === 'style') {
        acc.push({ ...currValue, showStep: true });
      } else if (options?.[currIndex - 1]?.id === selectedKey) {
        acc.push({ ...currValue, showStep: true });
      } else {
        acc.push(currValue);
      }
      return acc;
    }, []);
  };

  // in case of no model style
  useEffect(() => {
    if (
      applianceData?.name === applianceName &&
      modelOptionsData &&
      !modelStylesData
    ) {
      if (!localItem) {
        const updatedOptionsData = modelOptionsData.filter((item) => {
          return applianceData?.options?.indexOf(item.id) !== -1;
        });
        const mO = stepByStepOptions(updatedOptionsData, 'style');
        setModelOptions(mO);
      }
    }
  }, [
    applianceData,
    applianceName,
    modelStylesData,
    modelOptionsData,
    localItem,
    setModelOptions,
  ]);

  useEffect(() => {
    genrateApplianceImage(
      applianceName,
      appliance,
      applianceData?.configureOrder,
    );
  }, [applianceData, appliance, applianceName, genrateApplianceImage]);

  const fetchModelNameWthPricing = useCallback(() => {
    let stackingArr = [];
    let pricingObj = {};
    if (applianceData?.pricing) {
      for (var obj of applianceData.pricing) {
        const onSelection = obj?.onSelection;
        const keys = Object.keys(onSelection);
        if (keys.length > 0) {
          let match = [];
          for (var key of keys) {
            if (Array.isArray(obj?.onSelection?.[key])) {
              const valSelection = !!obj?.onSelection?.[key]?.find(
                (val) => val == appliance?.[key]?.id,
              );
              match = [...match, valSelection];
            } else {
              match = [
                ...match,
                obj?.onSelection?.[key] == appliance?.[key]?.id,
              ];
            }
          }
          pricingObj = match.every(Boolean) ? { ...obj } : pricingObj;
          // Adding all the matching model to add stacking price ex: Rangehood
          stackingArr = [
            ...stackingArr,
            ...(match.every(Boolean) && applianceData?.stackingModelName
              ? [pricingObj]
              : []),
          ];
        } else {
          pricingObj = { ...obj };
        }
      }
    }

    if (stackingArr?.length > 0) {
      pricingObj = stackingArr[0];
    }

    return {
      ...pricingObj,
      ...(pricingObj.modelName === 'auto' && {
        modelName: modelPricing.modelName ?? appliance?.modelPricing?.modelName,
      }),
      ...(stackingArr?.length > 0 && { stackingArr }),
    };
  }, [appliance, applianceData]);

  useEffect(() => {
    setModelPricing(fetchModelNameWthPricing());
  }, [fetchModelNameWthPricing]);

  // on model i.e style selection, load the relevant other options
  const onModelSelection = (key, selectedStyle) => {
    setAppliance({
      [key]: selectedStyle,
      ...(selectedStyle?.defaultProperty && selectedStyle?.defaultProperty),
    });

    const populateOptions = modelOptionsData.reduce((acc, item) => {
      if (selectedStyle?.options?.indexOf(item.id) !== -1) {
        // only shows required nested options from multiple options
        const nestedOptions = selectedStyle?.nestedOptions;
        if (nestedOptions && item.id in nestedOptions) {
          const updatedItem = {
            ...item,
            opt: item?.opt.filter(
              (f) => nestedOptions[item.id].indexOf(f.id) !== -1,
            ),
          };
          acc.push(updatedItem);
        } else {
          acc.push(item);
        }
      }
      return acc;
    }, []);
    const mO = stepByStepOptions(populateOptions, key);
    setModelOptions(mO);
  };

  // on appliance option selection,
  // - set the selected option data
  // - populate/ remove the relevant model option if exist
  const onOptionSelection = (key, selectedOption) => {
    setAppliance({
      ...appliance,
      [key]: selectedOption,
    });

    // If autoSelection is present, select the relevant option.
    const { autoSelection } = selectedOption || {};

    if (autoSelection) {
      const k = Object.keys(autoSelection)[0];
      const findSelectionObj = modelOptions.find((o) => o.id === k);

      let autoSeletionData = findSelectionObj?.opt?.find(
        (o) => o.id == autoSelection[k],
      );
      autoSeletionData = pricingHelper(autoSeletionData, appliance);

      setAppliance({
        ...appliance,
        [key]: selectedOption,
        [k]: autoSeletionData,
      });
    }

    const updatedSelection = { ...appliance, [key]: selectedOption };

    let updatedOptionsData = [];
    if (!appliance[key]?.populate && selectedOption?.populate) {
      const populateArr = modelOptionsData.filter(
        (mO) => mO.if === selectedOption?.id,
      );
      const selectednOptionIndex = modelOptions.findIndex((x) => x.id === key);
      updatedOptionsData = [...modelOptions];
      updatedOptionsData.splice(selectednOptionIndex + 1, 0, ...populateArr);
    } else if (selectedOption?.removeAssociated) {
      updatedOptionsData = modelOptions.filter((mO) => {
        if (mO.if === selectedOption?.removeAssociated) {
          delete updatedSelection[mO.id];
        }
        return mO.if !== selectedOption?.removeAssociated;
      });
      setAppliance(updatedSelection);
    }

    if (updatedOptionsData?.length > 0) {
      const mO = stepByStepOptions(updatedOptionsData, key);
      setModelOptions(mO);
    } else {
      const mO = stepByStepOptions(modelOptions, key);
      setModelOptions(mO);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadConfiguredImage = () => {
    const { imagesSet } = configuredApplianceData || {};
    // console.log('imagesSet', imagesSet);
    let parentImg = '';
    let childImg = [];
    if (
      applianceData?.baseModelSrc &&
      !appliance['style']?.modelSrc &&
      !appliance['colours']?.modelSrc
    ) {
      parentImg = applianceData?.baseModelSrc;
      childImg = imagesSet;
    } else {
      const [p, ...c] = imagesSet || [];
      if (!p) {
        parentImg = applianceData?.defaultModelSrc;
      } else {
        parentImg = p;
      }
      childImg = c;
    }

    return (
      <>
        {parentImg && (
          <Image
            classes="firstChildImageBox"
            onLoad={(img) => setBoxHeight(img.target.offsetHeight + 100)}
            name={parentImg}
          />
        )}
        {childImg?.length > 0 &&
          childImg?.map((src) => (
            <Image key={src} classes="childImageBox" name={src} />
          ))}
      </>
    );
  };

  const fetchbackgroundImg = () => {
    let backgroundImg = null;
    if (configuredApplianceData?.style?.bg) {
      backgroundImg = configuredApplianceData?.style?.bg;
    } else if (applianceData?.bg) {
      backgroundImg = applianceData?.bg;
    }
    return backgroundImg;
  };

  const fetchMaskImg = () => {
    let maskImg = null;
    if (configuredApplianceData?.style?.maskBg) {
      const src = configuredApplianceData?.style?.maskBg;
      maskImg = <Image key={src} classes="childImageBox" name={src} />;
    } else if (applianceData?.maskBg) {
      const src = applianceData?.maskBg;
      maskImg = <Image key={src} classes="childImageBox" name={src} />;
    }
    return maskImg;
  };

  const renderPricing = () => {
    let pricingText = `Configure your ${applianceName}`;
    let pricing;
    if (Object.keys(modelPricing).length > 0) {
      const mName = modelPricing?.modelName;
      const mPricing =
        typeof displayCurrency(modelPricing) === 'object'
          ? displayCurrency(modelPricing)?.[appliance['style']?.id]
          : displayCurrency(modelPricing);

      let localData = false;

      // if data is saved, avoid duplicate
      if (
        localItem &&
        localItem?.configuration?.style?.id === appliance['style']?.id
      ) {
        localData = true;
        pricing = configuredApplianceData?.totalPricing;
      }

      // if model comes without base pricing & totalPricing is 0, add model pricing on model generation.
      if (
        !displayCurrency(appliance['style']) &&
        !configuredApplianceData?.totalPricing
      ) {
        pricing = mPricing + configuredApplianceData?.totalPricing;
      }
      // if model comes without base pricing & local data is not available
      else if (
        !displayCurrency(appliance['style']) &&
        !localItem?.configuration
      ) {
        pricing = mPricing + configuredApplianceData?.totalPricing;
      }
      // if model comes without base pricing & local data flag is false
      else if (!displayCurrency(appliance['style']) && !localData) {
        pricing = mPricing + configuredApplianceData?.totalPricing;
      }
      // if model comes without base pricing & local data is available but selection changed happened
      else if (
        !displayCurrency(appliance['style']) &&
        localData &&
        selectionChanged
      ) {
        pricing = mPricing + configuredApplianceData?.totalPricing;
      } else {
        pricing = configuredApplianceData?.totalPricing;
      }

      // Stacking price ex: Rangehood
      pricingText = `${mName} ($${pricing})`;
      if (modelPricing?.stackingArr) {
        pricingText = modelPricing?.stackingArr.map((item) => (
          <span style={{ fontSize: '16px' }} key={item.modelName}>
            {`${item.modelName} ($${
              displayCurrency(item?.altPrice) || displayCurrency(item)
            })`}
            <br />
          </span>
        ));
      }
    }
    return pricingText;
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      maxWidth="lg"
      marginLeft="auto"
      marginRight="auto"
      className="VisualizerMainContainer"
    >
      <Grid item xs={12}>
        <Box className="VisualizerHeading">
          <Typography variant="h1" textAlign="center">
            ELMIRA DESIGN LOFT
          </Typography>
          <Typography variant="h6" textAlign="center">
            {`${data?.name?.toUpperCase()} COLLECTION`}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} sx={{ mb: 1 }}>
        <Box className="CreateKitchenSection">
          <Box className="HeaderSectionThird">
            <Box className="HeaderCenterSide">
              <Box className="CabinetColorSection">
                {!fireviewKitchen && (
                  <Box
                    variant="body1"
                    component=""
                    onClick={() => navigate('../')}
                    className="BackButton"
                  >
                    &#8592; Back
                  </Box>
                )}
                <Typography variant="h6">
                  {applianceData?.msg ||
                    'SELECT MODEL THEN COLOUR AND ADDITIONAL OPTIONS WILL OPEN'}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box className="MainKitchenSection" style={{ minHeight: boxHeight }}>
            <Box className="ApplianceBoxLeft">
              <Box className="ApplianceName">
                <Typography variant="h4" textAlign="center">
                  {renderPricing()}
                </Typography>
              </Box>
              <Box className="parentApplianceContainer">
                <picture
                  className={
                    applianceName === 'rangehood'
                      ? 'parentApplianceImageBox'
                      : 'parentApplianceImageBox-apply'
                  }
                  style={
                    fetchbackgroundImg()
                      ? {
                          backgroundImage: `url(
                    ${require(`../../../assets/${fetchbackgroundImg()}`)}
                  )`,
                        }
                      : {}
                  }
                >
                  {loadConfiguredImage()}
                  {fetchMaskImg()}
                </picture>
              </Box>
            </Box>
            <Box className="ApplianceBoxRight">
              <ApplianceOptions
                modelStylesData={modelStylesData}
                onModelSelection={onModelSelection}
                onOptionSelection={onOptionSelection}
                modelOptions={modelOptions}
                selectedOptions={appliance}
                setSelectionChanged={setSelectionChanged}
              />
            </Box>
          </Box>
          <Box className="FooterSection FooterSectionSecond">
            <Box className="FooterLeftSide">
              <Button
                onClick={() => {
                  save(modelPricing);
                  setSelectionChanged(false);
                  setOpen(true);
                }}
                className="CommonButton SaveBtn"
                variant="contained"
                disabled={Object.keys(modelPricing).length == 0}
              >
                {fireviewKitchen ? 'Save' : 'Save First'}
              </Button>
              <Button
                className="CommonButton SaveBtn"
                variant="contained"
                disabled={!localItem}
                onClick={() => navigate('../dream-kitchen')}
              >
                {fireviewKitchen
                  ? 'THEN VIEW YOUR COMPLETED STOVE'
                  : 'THEN VIEW YOUR DREAM KITCHEN'}
              </Button>
              <Button
                onClick={reset}
                className="CommonButton SaveBtn"
                variant="contained"
                disabled={!localItem}
              >
                Reset
              </Button>
            </Box>
            {!fireviewKitchen && (
              <Typography variant="body1" textAlign="center">
                <b>OR SELECT A PRODUCT BELOW</b> TO BUILD ANOTHER APPLIANCE.
              </Typography>
            )}
          </Box>
        </Box>
      </Grid>
      {data?.configuratorIcon && !fireviewKitchen && (
        <Grid item xs={12}>
          <Box className="ProductApplianceBox">
            <ul>
              {data?.configuratorIcon?.map((item) => (
                <li key={item.id}>
                  <a>
                    <Box
                      className="ProductApplianceImg"
                      onClick={() => navigate(`../${item.id}/product-studio`)}
                    >
                      <Image
                        name={
                          item.id === applianceName
                            ? item?.selectedImg
                            : item?.unselectedImg
                        }
                      />
                    </Box>
                    <Typography variant="body1" textAlign="center">
                      {item.name}
                    </Typography>
                  </a>
                </li>
              ))}
            </ul>
          </Box>
        </Grid>
      )}
      <SimpleDialog
        open={open}
        handleClose={handleClose}
        dialogBody={
          <>
            <DialogTitle id="alert-dialog-title">
              <Box className="TextCenter">SAVED</Box>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Box sx={{ pb: 3 }} className="TextCenter">
                  {/* <SaveIcon fontSize="large" /> */}
                  <Typography className="SaveMsg">
                    Your selections saved.
                  </Typography>
                </Box>
              </DialogContentText>
            </DialogContent>
            {/* <DialogActions>
              <Box className="ContentCenter">
                <Button variant="contained" onClick={() => setOpen(false)}>
                  Ok
                </Button>
              </Box>
            </DialogActions> */}
          </>
        }
      />
    </Grid>
  );
};

export default ProductStudioStage1;
